module.exports = __webpack_public_path__ + "static/media/icon_time.4e3ae8c4.svg";